import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import BookmarkIcon from '@material-ui/icons/BookmarkBorder';
import InfoIcon from '@material-ui/icons/Info';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ShareIcon from '@material-ui/icons/Share';
import { withStyles } from '@material-ui/core/styles';
import ShareOptions from './ShareOptions';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { getCityName } from 'utils/';
import links from 'utils/links';

const styles = theme => ({
  cardContainer: {
    height: '100%',
    position: 'relative',
  },
  cardContent: {
    paddingBottom: '90px',
    fontSize: '15px',
  },
  actions: {
    marginTop: '20px',
    position: 'absolute',
    width: '100%',
    bottom: '0',
    backgroundColor: theme.palette.primary.main,
    height: '40px',
  },
  infoIcon: {
    color: theme.palette.secondary.main,
    fontSize: '0.5em',
  },
  actionIcon: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    margin: '5px',
    marginTop: '-30px',
    boxShadow: '1px 1px grey',
    '&:hover': {
      '@media': {
        backgroundColor: '#391b16',
      },
      '&:focus': {
        backgroundColor: 'grey',
      },
    },
  },
  actionButton: {
    position: 'absolute',
    left: -theme.spacing.unit * 3 - 4,
    top: 30,
    paddingLeft: theme.spacing.unit * 5,
    textTransform: 'none',
  },
  media: {
    height: 180,
    position: 'relative',
    width: '100%',
    marginTop: '-10px',
  },
  inline: {
    // display: 'inline',
    fontSize: '0.75rem',
    fontWeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    // lineHeight: '16px' /* fallback */,
    maxHeight: '32px' /* fallback */,
    WebkitLineClamp: 1 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
  pushRight: {
    marginLeft: 'auto',
  },
  eventName: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '1.125rem',
    fontWeight: 'medium',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
  eventSummary: {
    fontSize: '15px',
    // overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    lineHeight: '1.5rem',
    maxHeight: '32px' /* fallback */,
    WebkitLineClamp: 2 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
});

class RnFEvent extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const {
      classes,
      name,
      // curatedBy,
      date,
      location,
      img,
      summary,
    } = this.props;
    var cityName = getCityName().toLowerCase();
    if (cityName === 'bangalore') {
      cityName = 'bengaluru';
    }
    return (
      <Card className={classes.cardContainer}>
        <CardHeader
          // title={name}
          title={<div className={classes.eventName}>{name}</div>}
          subheader={
            <div>
              {/* <Typography
                variant="subtitle2"
                classes={{ root: classes.inline }}
              >
                Curated by {curatedBy ? curatedBy : 'Not Available'}
              </Typography>
              <br /> */}
              <Typography
                variant="subtitle2"
                classes={{ root: classes.inline }}
              >
                {date + ' | ' + location}
              </Typography>
            </div>
          }
        />
        <CardMedia
          className={classNames(classes.media)}
          image={img ? img : '/img/na.png'}
        >
          <a href={links.ourLiveExperienceCities(cityName)}>
            <Button
              className={classes.actionButton}
              color="secondary"
              variant="contained"
            >
              Attend
            </Button>
          </a>
        </CardMedia>
        <CardContent className={classes.cardContent}>
          <Typography variant="body1" className={classes.eventSummary}>
            {summary}
          </Typography>
          {/* <Typography align="right" variant="body2">
            …read more
          </Typography> */}
        </CardContent>
        <CardActions className={classes.actions} disableActionSpacing>
          <IconButton className={classes.infoIcon} aria-label="Information">
            <InfoIcon />
          </IconButton>
          <div className={classes.pushRight}>
            {localStorage.getItem('tsUserInfo') ? (
              <IconButton
                className={classes.actionIcon}
                color="secondary"
                aria-label="Bookmark"
              >
                <BookmarkIcon />
              </IconButton>
            ) : (
              <React.Fragment>
                <IconButton
                  className={classes.actionIcon}
                  color="secondary"
                  aria-label="Bookmark"
                  onClick={this.handleClickOpen}
                >
                  <BookmarkIcon />
                </IconButton>
                <Dialog
                  open={this.state.open}
                  onClose={this.handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    {'Talking Street '}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Please Sign-in or Sign-up to proceed/Bookmark
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={this.handleClose}
                      color="primary"
                      autoFocus
                    >
                      Ok
                    </Button>
                  </DialogActions>
                </Dialog>
              </React.Fragment>
            )}
            <ShareOptions
              shareButton={
                <IconButton className={classes.actionIcon} aria-label="Share">
                  <ShareIcon />
                </IconButton>
              }
            />
            <IconButton className={classes.actionIcon} aria-label="Location">
              <LocationOnIcon />
            </IconButton>
          </div>
        </CardActions>
      </Card>
    );
  }
}

RnFEvent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RnFEvent);
